import React from 'react';
import styled from 'styled-components';

const My_Section = styled.section`
padding: 50px 0px 38px;
background-color: ${props => props.bg};
background-image: ${props => props.bg_Img ? "url(" + props.bg_Img + ")" : "none"};
background-size: cover;
`;

export default function Section(props) {
    return (
        <My_Section bg={props.bg} bg_Img={props.bg_Img}>
            {props.children}
        </My_Section>
    )
}
